export function getBitwiseEnumParts(value: number, enumeration: object): number[] {
    let parts: number[] = []
    for (const option of Object.keys(enumeration)) {
        // tslint:disable-next-line:no-bitwise
        if (typeof option !== 'number' && value & +option) parts.push(+option)
    }
    return parts
}
